// extracted by mini-css-extract-plugin
export var slides = "dahsboardSlideshow-module--slides--e4lD0";
export var slideSection = "dahsboardSlideshow-module--slideSection--emsq0";
export var active = "dahsboardSlideshow-module--active--Z2Jg5";
export var slideIn = "dahsboardSlideshow-module--slideIn--DLFO+";
export var slideshowNav = "dahsboardSlideshow-module--slideshowNav--GikRL";
export var slideshowCont = "dahsboardSlideshow-module--slideshowCont--h159O";
export var prevBtn = "dahsboardSlideshow-module--prevBtn--ApQm1";
export var nextBtn = "dahsboardSlideshow-module--nextBtn--Mi45P";
export var fadeIn = "dahsboardSlideshow-module--fadeIn--FyrEn";